(function()
{
    "use strict";

	function Fullscreen()
	{
        this.available = false;

        this.requestFullscreen = null;
        this.cancelFullscreen = null;

        this.performCheck();
	}

	var p = Fullscreen.prototype;

	p.performCheck = function()
	{
        var el = document.documentElement;

        var variants = [
            'requestFullscreen',
            'requestFullScreen',
            'webkitRequestFullscreen',
            'webkitRequestFullScreen',
            'msRequestFullscreen',
            'msRequestFullScreen',
            'mozRequestFullScreen',
            'mozRequestFullscreen'
        ];

        for (var i = 0; i < variants.length; i++)
        {
            if (el[variants[i]])
            {
                this.requestFullscreen = variants[i];
                break;
            }
        }

        if(this.requestFullscreen)
        {
            variants = [
                'cancelFullScreen',
                'exitFullscreen',
                'webkitCancelFullScreen',
                'webkitExitFullscreen',
                'msCancelFullScreen',
                'msExitFullscreen',
                'mozCancelFullScreen',
                'mozExitFullscreen'
            ];

            for (i = 0; i < variants.length; i++)
            {
                if (document[variants[i]])
                {
                    this.cancelFullscreen = variants[i];
                    break;
                }
            }
        }

        this.available = (!!this.requestFullscreen && !!this.cancelFullscreen);
	};

    p.request = function(element)
    {
        if(!this.available) return;

        try
        {
            element[this.requestFullscreen]();
        }
        catch(e)
        {
            console.log("Fullscreen Request Failed");
            console.log(e);
        }
    };

    p.cancel = function()
    {
        if(!this.available) return;

        try
        {
            document[this.cancelFullscreen]();
        }
        catch(e)
        {
            console.log("Fullscreen Cancel Failed");
            console.log(e);
        }
    };

	cm.Fullscreen = new Fullscreen();
})();